export const GET_DIMENSIONS_WATCHER =
  "app/ReportsV2/WidgetResultByDimensionEngagement/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS =
  "app/ReportsV2/WidgetResultByDimensionEngagement/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED =
  "app/ReportsV2/WidgetResultByDimensionEngagement/GET_DIMENSIONS_FAILED"
